//@ts-ignore - json-logic-js hasn't got types
import jsonLogic from "json-logic-js";
import Validate, { ValidateJson } from "../interfaces/Validate";
import ComponentValue from "../interfaces/ComponentValue";
import { InputError, InputErrorEnum } from "../interfaces/InputError";
import { FormStateValues } from "../interfaces/Form/State";
import InputDataType from "../interfaces/InputDataType";
import AresApi from "../api/AresApi";

export const applyJsonLogic = (json: any, values: any) => {
  return jsonLogic.apply(json, values);
};

export const validateComponent = (
  dataType: InputDataType,
  name: string | undefined,
  value: ComponentValue,
  validation: Validate | undefined,
  allValues?: FormStateValues
) => {
  let error: InputError;
  if (dataType === InputDataType.array) {
    if (!value || (value as []).length < 1) return InputErrorEnum.required;
  }
  if (dataType === InputDataType.email) {
    error = validateEmail(
      value !== undefined ? (value as string) : "",
      validation
    );
    if (error) return error;
  }
  if (dataType === InputDataType.iban) {
    error = validateValidIBAN(
      value !== undefined ? (value as string) : "",
      validation
    );
    if (error) return error;
  }

  if (!validation) return;
  if (
    validation.required &&
    (value === "" || value === undefined || value === false || value === null)
  ) {
    if (name === "Radio" || name === "Select")
      return InputErrorEnum.requiredMultiple;
    if (name === "Checkbox") return InputErrorEnum.requiredCheckbox;
    return InputErrorEnum.required;
  }
  if (dataType === InputDataType.number) {
    error = validateNumber(
      value !== undefined ? (value as number) : 0,
      validation
    );
    if (error) return error;
  }
  if (dataType === InputDataType.string) {
    error = validateString(
      value !== undefined ? (value as string) : "",
      validation
    );
    if (error) return error;
  }
  if (dataType === InputDataType.phone) {
    if(validation.phoneNa){
      error = validatePhoneNumberNa(
        value !== undefined ? (value as string) : "",
        validation
      );
    }else{
      error = validatePhoneNumber(
        value !== undefined ? (value as string) : "",
        validation
      );
    }
    if (error) return error;
  }
  if (validation.regex) {
    error = validateRegex(
      value !== undefined ? (value as string) : "",
      validation
    );
    if (error) return error;
  }
  if (validation.validchar) {
    error = validateValidChar(
      value !== undefined ? (value as string) : "",
      validation
    );
    if (error) return error;
  }
  if (validation.idHolder) {
    error = validateIdHolder(
      value !== undefined ? (value as string) : "",
      validation
    );
    if (error) return error;
  }
  if (validation.aresIco) {
    error = validateAresIco(
      value !== undefined ? (value as string) : "",
      validation
    );
    if (error) return error;
  }
  if (validation.dateWithSlash) {
    error = validateDateWithSlashAndNa(
      value !== undefined ? (value as string) : ""
    );
    if (error) return error;
  }
  if (validation.json && allValues) {
    validation.json.forEach((json: ValidateJson) => {
      const jsonError = validateJson(json, allValues);
      if (jsonError) error = jsonError;
    });
    if (error) return error;
  }
};

export const validatePhoneNumber = (value: string, validate?: Validate) => {
  if (value) {
    const re = /^((0{2}|\+)[0-9]{1,4}[- ]?)?[1-9][0-9]{2,4}[- ]?[0-9]{3,5}[- ]?[0-9]{3,5}$/;
    if (!re.test(value)) return InputErrorEnum.phone;
  }
  return validateString(value, validate);
};

export const validatePhoneNumberNa = (value: string, validate?: Validate) => {
  if (value.toLowerCase() === 'na') {
    return
  }
  return validatePhoneNumber(value, validate);
};

export const validateEmail = (value: string, validate?: Validate) => {
  if (value) {
    const re =  /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;
    if (!re.test(value)) return InputErrorEnum.email;
  }
  return validateString(value, validate);
};

export const validateJson = (
  validation: ValidateJson,
  values: FormStateValues
) => {
  if (!applyJsonLogic(validation.condition, values))
    return validation.error || InputErrorEnum.general;
};

export const validateNumber = (
  value: number,
  validate?: Validate
): InputError => {
  if (!validate) return;
  if (validate.max !== undefined && value > validate.max) {
    return InputErrorEnum.maxNum;
  }
  if (validate.min !== undefined && value < validate.min) {
    return InputErrorEnum.minNum;
  }
};

export const validateRegex = (value: string, validate?: Validate) => {
  if (!validate || !validate.regex || !value) return;
  const re = new RegExp(validate.regex.pattern);
  if (!re.test(value)) return validate.regex.error || InputErrorEnum.general;
};

export const validateString = (value: string, validate?: Validate) => {
  if (!validate) return;
  const length = value.length;
  if (validate.max !== undefined && length > validate.max) {
    return InputErrorEnum.maxStr;
  }
  if (validate.min !== undefined && length < validate.min) {
    return InputErrorEnum.minStr;
  }
};

export const validateValidChar = (value: string, validate?: Validate) => {
  if (!validate) return;
  if (
    value &&
    value.match(
      /^[a-z0-9./;A-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆŠŽ∂ðěřĚŮů&ŘĜĝĞğĠġĢģŎŏĈĉĤĥĴĵŜŝŴŵŶŷẐẑ '-]+$/
    )
  ) {
    return;
  } else {
    return InputErrorEnum.validChars;
  }
};

export const validateValidIBAN = (value: string, validate?: Validate) => {
  if (!value) return;
  const sanitizevalue = value.replace(/\s/g, "");
  const re = new RegExp(/^[A-Z]{2}[0-9]{22}$/);
  if (!re.test(sanitizevalue)) return InputErrorEnum.errIBAN;
};

export const validateRegNum = (value: string, validate?: Validate) => {
  if (!value) return;
  const sanitizevalue = value.replace(/\s/g, "");
  const re = new RegExp( /^\d{2}\/\d{3,4}\/\d{2}-[A-Z](\/[A-Z])?$/);
  if (!re.test(sanitizevalue)) return InputErrorEnum.errRegNum;
};

export const validateIdHolder = (value: string, validate?: Validate) => {
  if (!value) return;
  const sanitizevalue = value.replace(/\s/g, "");
  const re = new RegExp( /^[0-9]{11}$/);
  if (!re.test(sanitizevalue)) return InputErrorEnum.errIdHolder;
};

export const validateIcoFormat = (value: string) => {
  if (!value) return;
  const sanitizevalue = value.replace(/\s/g, "");
  const re = new RegExp(/^[0-9]{8}$/);
  if (!re.test(sanitizevalue)) return 'err.icNotValid';
};

export const validateAresIco = (value: string, validate?: Validate) => {
  if (!validate?.aresIco || !value) return;

  const formatError = validateIcoFormat(value);
  if (formatError) return formatError;

  const validationState = AresApi.getSubjectValidationState(value);
  if (validationState === 'valid') return;
  if (validationState === 'invalid') return 'err.icNotFoundInAres';
  return 'err.icAresValidationFailed';
};

export const validateValidDateSimple = (value: string, validate?: Validate) => {
  if (!value) return;
  const sanitizevalue = value.replace(/\s/g, "");
  const re = new RegExp(/^([0-3][0-9]\.)?[0-1][0-9]\.[1-2][0-9]{3}$/);
  if (!re.test(sanitizevalue)) return InputErrorEnum.errDateSimple;
};

export const isProperDate = (value: string) => {
  const isMonthAndYear = new RegExp(/^([0-1][0-9])\/([1-2][0-9]{3})$/);
  const isFullDate = new RegExp(
    /^([0-3][0-9])\.([0-1][0-9])\.([1-2][0-9]{3})$/
  );

  const matchMonthAndYear = value.match(isMonthAndYear);
  const matchFullDate = value.match(isFullDate);

  if (matchMonthAndYear) {
    if (
      parseInt(matchMonthAndYear[1]) < 1 ||
      parseInt(matchMonthAndYear[1]) > 12
    )
      return false;
    if (
      parseInt(matchMonthAndYear[2]) < 1900 ||
      parseInt(matchMonthAndYear[2]) > 2100
    )
      return false;
  }

  if (matchFullDate) {
    if (parseInt(matchFullDate[1]) < 1 || parseInt(matchFullDate[1]) > 31)
      return false;
    if (parseInt(matchFullDate[2]) < 1 || parseInt(matchFullDate[2]) > 12)
      return false;
    if (parseInt(matchFullDate[3]) < 1900 || parseInt(matchFullDate[3]) > 2100)
      return false;
  }

  return true;
};

export const validateDateWithSlash = (value: string) => {
  if (!value) return;

  if (!isProperDate(value)) return InputErrorEnum.errDateWithSlash;

  const re = new RegExp(
    /^([0-3][0-9]\.)[0-1][0-9]\.[1-2][0-9]{3}$|^([0-1][0-9]\/[1-2][0-9]{3}$)$/
  );
  if (!re.test(value)) return InputErrorEnum.errDateWithSlash;
};

export const validateDateWithSlashAndNa = (value: string) => {
  if (!value) return;

  if (!isProperDate(value)) return InputErrorEnum.errDateWithSlashAndNa;

  const re = new RegExp(
    /^([0-3][0-9]\.)[0-1][0-9]\.[1-2][0-9]{3}$|^([0-3][0-9]\/[1-2][0-9]{3}$)$|^N\/A$|^n\/a$/
  );
  if (!re.test(value)) return InputErrorEnum.errDateWithSlashAndNa;
};
